import type { Caller } from "@repo/common";
import type { Call } from "../types";

export function phoneKey(value: string = "") {
	const digits = value.replace(/\D/g, "");
	const international = digits.startsWith("00972") ? digits.slice(2) : digits;
	return international.startsWith("972")
		? "0" + international.slice(3)
		: international;
}
export function matchesCaller(caller: Caller, search: string) {
	const text = search.trim().toLocaleLowerCase();
	if (!text) return true;
	if (
		caller.name?.toLocaleLowerCase().includes(text) ||
		caller.email?.toLocaleLowerCase().includes(text)
	)
		return true;
	if (!/^[+\d\s().-]+$/.test(text)) return false;
	const digits = text.replace(/\D/g, "");
	return (
		!!digits &&
		(phoneKey(caller.phoneNumber).includes(phoneKey(text)) ||
			caller.phoneNumber.replace(/\D/g, "").includes(digits))
	);
}
export function customerPhone(call: Call) {
	const outbound =
		call.isOutbound ||
		call.direction === "outbound" ||
		call.source === "outbound_sip" ||
		call.source === "outbound_playbook_task" ||
		!!call.outboundTaskId;
	return outbound
		? call.destinationNumber ||
				call.callerPhoneNumber ||
				call.inboundNumber ||
				call.from ||
				""
		: call.callerPhoneNumber || call.from || call.caller.phone;
}
export function callerDate(value: unknown): Date | null {
	if (!value) return null;
	const timestamp = value as { toDate?: () => Date };
	const date = timestamp.toDate
		? timestamp.toDate()
		: new Date(value as string);
	return Number.isNaN(date.getTime()) ? null : date;
}

export function callerDocumentId(phone: string) {
	const digits = phone.replace(/\D/g, "");
	if (!digits) return "_unknown";
	if (digits.startsWith("00972")) return "+" + digits.slice(2);
	if (digits.startsWith("0") && !phone.trim().startsWith("+"))
		return "+972" + digits.slice(1);
	return "+" + digits;
}
